// Messaging service (Firebase wrapper)
export {
  requestPermission,
  getPermissionStatus,
  getToken,
  deleteToken,
  unregisterDeviceForRemoteMessages,
  onTokenRefresh,
  onForegroundMessage,
  setBackgroundMessageHandler,
  getInitialNotification,
  onNotificationOpenedApp,
  getDevicePlatform,
  AUTHORIZATION_STATUS,
} from "./messaging-service";
export type { AuthorizationStatus, RemoteMessage } from "./messaging-service";

// Notification payload types
export { NotificationDataSchema } from "./types";
export type { NotificationData, PermissionStatus, PushNotificationStatus } from "./types";

// Navigation
export { navigateToNotification } from "./navigate-to-notification";

// Device token API (plain client)
export { createDeviceTokenApi } from "./device-token-api";
export type { DeviceTokenApi, DeviceTokenApiOptions } from "./device-token-api";

// Device token React Query hook
export {
  useDeviceToken,
  STATUS_QUERY_KEY,
  PermissionDeniedError,
  RegistrationCancelledError,
  teardownDeviceToken,
} from "./use-device-token";
export type { UseDeviceTokenOptions } from "./use-device-token";

// Push notification lifecycle hook
export { usePushNotifications } from "./use-push-notifications";
export type { UsePushNotificationsOptions } from "./use-push-notifications";

// Notification blacklist API (plain client)
export { createNotificationBlacklistApi } from "./notification-blacklist-api";
export type { NotificationBlacklistApi, NotificationBlacklistApiOptions } from "./notification-blacklist-api";

// Notification blacklist React Query hook
export { useNotificationBlacklist } from "./use-notification-blacklist";
export type { UseNotificationBlacklistOptions } from "./use-notification-blacklist";
